import { combineReducers } from 'redux';
import { handleActions, combineActions } from 'redux-actions';
import * as actionTypes from './constants';

export const isLoadingWizardData = handleActions(
  {
    [combineActions(
      actionTypes.FETCH_CAMPAIGN_WIZARD_DATA_FAILURE,
      actionTypes.FETCH_CAMPAIGN_WIZARD_DATA_SUCCESS,
    )]: () => false,
    [combineActions(
      actionTypes.FETCH_CAMPAIGN_WIZARD_DATA_REQUEST,
    )]: () => true,
  },
  false,
);

export const wizardData = handleActions(
  {
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.FETCH_CAMPAIGN_WIZARD_DATA_REQUEST,
      actionTypes.FETCH_CAMPAIGN_WIZARD_DATA_FAILURE,
      actionTypes.RESET_CAMPAIGN_DATA,
    )]: () => ({}),
    [combineActions(
      actionTypes.FETCH_CAMPAIGN_WIZARD_DATA_SUCCESS,
    )]: (state, { payload }) => payload,
  },
  {},
);

export const isLoadingCampaigns = handleActions(
  {
    [combineActions(
      actionTypes.FETCH_CAMPAIGNS_SUCCESS,
      actionTypes.FETCH_CAMPAIGNS_FAILURE,
    )]: () => false,
    [combineActions(
      actionTypes.FETCH_CAMPAIGNS_REQUEST,
    )]: () => true,
  },
  false,
);

export const campaigns = handleActions(
  {
    [combineActions(
      actionTypes.FETCH_CAMPAIGNS_REQUEST,
      actionTypes.FETCH_CAMPAIGNS_FAILURE,
    )]: () => [],
    [actionTypes.FETCH_CAMPAIGNS_SUCCESS]: (state, { payload }) => payload.campaigns,
    [actionTypes.DELETE_CAMPAIGN_SUCCESS]: (state, { payload }) =>
      (state || [])?.filter(d => d.id !== payload.id),
    [actionTypes.UPDATE_CAMPAIGN_SUCCESS]: (state, { payload }) => state?.map((d) => {
      if (d.id === payload.id) {
        return payload;
      }
      return d;
    }),
    [actionTypes.ADD_CAMPAIGN_SUCCESS]: (state, { payload }) => [
      ...state,
      payload,
    ],
  },
  [],
);

export const frequencies = handleActions(
  {
    [combineActions(
      actionTypes.FETCH_CAMPAIGNS_REQUEST,
      actionTypes.FETCH_CAMPAIGNS_FAILURE,
    )]: () => [],
    [actionTypes.FETCH_CAMPAIGNS_SUCCESS]: (state, { payload }) => payload.frequencies || [],
  },
  [],
);

export const locations = handleActions(
  {
    [combineActions(
      actionTypes.FETCH_CAMPAIGNS_REQUEST,
      actionTypes.FETCH_CAMPAIGNS_FAILURE,
    )]: () => [],
    [actionTypes.FETCH_CAMPAIGNS_SUCCESS]: (state, { payload }) => payload.locations || [],
  },
  [],
);

export const isUpdatingCampaign = handleActions(
  {
    [combineActions(
      actionTypes.ADD_CAMPAIGN_SUCCESS,
      actionTypes.ADD_CAMPAIGN_FAILURE,
      actionTypes.UPDATE_CAMPAIGN_SUCCESS,
      actionTypes.UPDATE_CAMPAIGN_FAILURE,
      actionTypes.DELETE_CAMPAIGN_SUCCESS,
      actionTypes.DELETE_CAMPAIGN_FAILURE,
    )]: () => false,
    [combineActions(
      actionTypes.ADD_CAMPAIGN_REQUEST,
      actionTypes.UPDATE_CAMPAIGN_REQUEST,
      actionTypes.DELETE_CAMPAIGN_REQUEST,
    )]: () => true,
  },
  false,
);

export const updateCampaignSuccess = handleActions(
  {
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.UPDATE_CAMPAIGN_REQUEST,
      actionTypes.UPDATE_CAMPAIGN_FAILURE,
      actionTypes.ADD_CAMPAIGN_REQUEST,
      actionTypes.ADD_CAMPAIGN_FAILURE,
      actionTypes.RESET_CAMPAIGN_DATA,
    )]: () => false,
    [combineActions(
      actionTypes.UPDATE_CAMPAIGN_SUCCESS,
      actionTypes.ADD_CAMPAIGN_SUCCESS,
    )]: () => true,
  },
  false,
);

export const isLoadingCampaign = handleActions(
  {
    [combineActions(
      actionTypes.FETCH_CAMPAIGN_FAILURE,
      actionTypes.FETCH_CAMPAIGN_SUCCESS,
    )]: () => false,
    [combineActions(
      actionTypes.FETCH_CAMPAIGN_REQUEST,
    )]: () => true,
  },
  false,
);

export const campaign = handleActions(
  {
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.FETCH_CAMPAIGN_REQUEST,
      actionTypes.FETCH_CAMPAIGN_FAILURE,
      actionTypes.RESET_CAMPAIGN_DATA,
    )]: () => ({}),
    [combineActions(
      actionTypes.FETCH_CAMPAIGN_SUCCESS,
    )]: (state, { payload }) => payload || {},
  },
  {},
);

export const campaignsError = handleActions(
  {
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.FETCH_CAMPAIGNS_REQUEST,
      actionTypes.FETCH_CAMPAIGNS_SUCCESS,
      actionTypes.FETCH_CAMPAIGNS_NEXT_REQUEST,
      actionTypes.FETCH_CAMPAIGNS_NEXT_SUCCESS,
      actionTypes.UPDATE_CAMPAIGN_REQUEST,
      actionTypes.UPDATE_CAMPAIGN_SUCCESS,
      actionTypes.DELETE_CAMPAIGN_REQUEST,
      actionTypes.DELETE_CAMPAIGN_SUCCESS,
      actionTypes.ADD_CAMPAIGN_REQUEST,
      actionTypes.ADD_CAMPAIGN_SUCCESS,
      actionTypes.FETCH_CAMPAIGN_WIZARD_DATA_REQUEST,
      actionTypes.FETCH_CAMPAIGN_WIZARD_DATA_SUCCESS,
      actionTypes.FETCH_CAMPAIGN_REQUEST,
      actionTypes.FETCH_CAMPAIGN_SUCCESS,
      actionTypes.RESET_CAMPAIGN_DATA,
    )]: () => ({}),
    [combineActions(
      actionTypes.FETCH_CAMPAIGNS_FAILURE,
      actionTypes.FETCH_CAMPAIGNS_NEXT_FAILURE,
      actionTypes.ADD_CAMPAIGN_FAILURE,
      actionTypes.UPDATE_CAMPAIGN_FAILURE,
      actionTypes.DELETE_CAMPAIGN_FAILURE,
      actionTypes.FETCH_CAMPAIGN_WIZARD_DATA_FAILURE,
    )]: (state, { payload }) => payload.error,
  },
  {},
);

export const campaignsSidepanelOpen = handleActions(
  {
    [actionTypes.OPEN_CAMPAIGNS_SIDEPANEL]: () => true,
    [combineActions(
      'LOCATION_CHANGE',
      actionTypes.CLOSE_CAMPAIGNS_SIDEPANEL,
    )]: () => false,
  },
  false,
);

export default combineReducers({
  isLoadingWizardData,
  wizardData,
  isLoadingCampaigns,
  campaigns,
  isLoadingCampaign,
  campaign,
  isUpdatingCampaign,
  updateCampaignSuccess,
  campaignsError,
  campaignsSidepanelOpen,
  locations,
  frequencies,
});
